import React, {useState} from 'react'
import  '../style/TrackItems.css'

import AddItemForm from './AddItemForm'
import ProductInfo from './ProductInfo'
import ProductDetails from './ProductDetails'

const TrackItems = () => {

    const defaultItemsState = [
        {
        id: 0, link: "https://www.amazon.de/", name: "HP Pavilion Gaming 15-Inch Micro-EDGE Laptop, Intel Core i5-9300H", description: "HP Pavilion Gaming 15-Inch Micro-EDGE Laptop, Intel Core i5-9300H Processor", initial_price: 800, current_price: 750, thresshold_price: 750, img_url: "./img/laptop.svg" },
        { id: 1, link: "https://www.amazon.de/", name: "HP Pavilion Gaming 15-Inch Micro-EDGE Laptop, Intel Core i5-9300H", description: "HP Pavilion Gaming 15-Inch Micro-EDGE Laptop, Intel Core i5-9300H Processor", initial_price: 300, current_price: 240, thresshold_price: 250, img_url: "https://m.media-amazon.com/images/I/51WdpaV2LjL._AC_SL1200_.jpg" },

]

    const [items, updateItems] = useState(defaultItemsState)


    function deleteItem (id) {
        updateItems(items.filter((item) => item.id !== id))
    }

    function addNewItem (item) {
      item.id = (items[items.length-1].id)+1;
      updateItems([...items, item]);
      console.log(items)
    }

    return(
        <div id="TrackItems">
                <AddItemForm addNewItem = {addNewItem}/>
                {
                    items.map(item => (
                        <div className="row" key = {"row" + item.id}> 
                         <ProductInfo item = { item } deleteItem = {deleteItem}/>
                         <ProductDetails item = { item } />
                        </div>
                    ))
                }
        </div>
    )
}

export default TrackItems